export default __webpack_public_path__ + "static/media/UFMA.bc171255.jpg";